export default "__VITE_ASSET__DfMOCYIY__"